"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMockCurrencyAmount = void 0;
const currency_1 = require("../../helpers/currency");
const locales_1 = require("../../internationalization/features/locales");
const formatMockCurrencyAmount = (cents, { locale = "en", country } = {}) => (0, currency_1.formatCurrencyFromCents)(cents, {
    isoLocale: (0, locales_1.getIsoLocaleFromCountry)(country, (0, locales_1.getLocalesFromIsoLocale)(locale)),
    currency: (0, currency_1.getCurrencyFromCountry)(country),
    cents: "alwaysVisible",
});
exports.formatMockCurrencyAmount = formatMockCurrencyAmount;
